import { motion, useReducedMotion } from "framer-motion";

/**
 * Lifts content into view on vertical scroll (opacity + translateY + shadow).
 */
export default function ScrollElevate({
  children,
  className = "",
  delay = 0,
  as = "div",
}) {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;

  if (reduce) {
    return <div className={className}>{children}</div>;
  }

  return (
    <Tag
      className={`scroll-elevate${className ? ` ${className}` : ""}`}
      initial={{ opacity: 0, y: 40, filter: "drop-shadow(0 0 0 rgba(0,0,0,0))" }}
      whileInView={{
        opacity: 1,
        y: 0,
        filter: "drop-shadow(0 18px 32px rgba(15, 26, 46, 0.12))",
      }}
      viewport={{ once: true, margin: "-6%" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Tag>
  );
}
